import { css } from 'styled-components';

export const printExpiredStyles = css``;
